import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { LogoService } from 'src/app/core/services/logo.service';
import { Router, NavigationEnd } from '@angular/router';
import { UserProfileService } from 'src/app/core/services/user.service';
import { TopbarComponent } from '../topbar/topbar.component';

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";

@Component({
  selector: "app-two-column-sidebar",
  templateUrl: "./two-column-sidebar.component.html",
  styleUrls: ["./two-column-sidebar.component.scss"],
})
export class TwoColumnSidebarComponent implements OnInit {
  public user: any;
  menu: any;
  toggle: any = true;
  menuItems: MenuItem[] = [];
  logoSmUrl: string = '';
  logoMdUrl: string = '';
  @ViewChild("sideMenu") sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @Output() mobileItemClicked = new EventEmitter<void>();

    constructor(
        private router: Router,
        public usr: UserProfileService,
        public topbar: TopbarComponent,
        private logoService: LogoService
    ) {
        this.usr.getObservableUser().subscribe(async (data) => {
            if (data) {
                this.user = await this.usr.getUser();
            }
        });
    }


    ngOnInit(): void {
        // Menu Items
        this.initMenu();

        // O menu (e o RouterLinkActive dos links) só existe/atualiza de verdade depois
        // que a navegação inicial termina (ela é assíncrona, mesma espera do AuthGuard).
        // Rodar em cada NavigationEnd garante que sempre refletimos a rota final, sem
        // depender de timing (evita destacar um item errado antes da navegação assentar).
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                setTimeout(() => this.initActiveMenu());
            }
        });

        this.logoService.getLogo$(3).subscribe(blobUrl => {
            this.logoMdUrl = blobUrl;
        });
        this.logoService.getLogo$(2).subscribe(blobUrl => {
            this.logoSmUrl = blobUrl;
        });
    }


  async initMenu() {
    this.user = await this.usr.getUser();
    this.menuItems = MENU;
    // menuItems só existe no DOM após este await resolver, então o ngAfterViewInit
    // (que roda antes disso) não encontra nenhum <a> pra marcar como ativo.
    // Repetimos aqui, depois do Angular renderizar o *ngFor, pra refletir a rota atual.
    setTimeout(() => this.initActiveMenu());
  }

  loadLogos() {
    this.logoService.getLogo$(2).subscribe(blobUrl => {
      this.logoSmUrl = blobUrl;
    });

    this.logoService.getLogo$(3).subscribe(blobUrl => {
      this.logoMdUrl = blobUrl;
    });
  }

  verifyItem(value: any) {
    return this.user.permissions.includes(value);
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /***
   * Activate drop down set
   */
  ngAfterViewInit() {
    this.initActiveMenu();
  }

  toggleSubItem(event: any) {
    event.preventDefault();
    let isCurrentMenuId = event.target.closest("a.nav-link");
    
    if (!isCurrentMenuId) return;
    
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    
    const isExpanded = isCurrentMenuId.getAttribute('aria-expanded') === 'true';
    const isMenuVisible = isMenu && isMenu.classList.contains('show');
    
    if (isExpanded || isMenuVisible) {
      isCurrentMenuId.setAttribute('aria-expanded', 'false');
      if (isMenu) {
        isMenu.classList.remove('show');
      }
      return;
    }
    
    let dropDowns = Array.from(
      document.querySelectorAll(".menu-dropdown .show")
    );
    dropDowns.forEach((node: any) => {
      node.classList.remove("show");
    });

    let subDropDowns = Array.from(
      document.querySelectorAll(".menu-dropdown .nav-link")
    );
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute("aria-expanded", "false");
    });

    if (event.target && event.target.nextElementSibling) {
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.add("show");
    }
  }

  toggleExtraSubItem(event: any, end: string = "") {
    event.preventDefault();
    let id: string | null = null;
    let parent: string | null = null;
    if (typeof event.target.id != "undefined") {
      const split = event.target.id.split(":");
      id = split[0];
      parent = split[1];
    }
    let isCurrentMenuId = event.target.closest("a.nav-link");
    
    if (!isCurrentMenuId) return;
    
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    
    const isExpanded = isCurrentMenuId.getAttribute('aria-expanded') === 'true';
    const isMenuVisible = isMenu && isMenu.classList.contains('show');
    
    if (isExpanded || isMenuVisible) {
      isCurrentMenuId.setAttribute('aria-expanded', 'false');
      if (isMenu) {
        isMenu.classList.remove('show');
      }
      return;
    }
    
    let dropDowns = Array.from(
      document.querySelectorAll(".extra-sub-menu" + end)
    );
    dropDowns.forEach((node: any) => {
      node.classList.remove("show");
    });

    let subDropDowns = Array.from(
      document.querySelectorAll(".menu-dropdown" + end + " .nav-link")
    );
    subDropDowns.forEach((submenu: any) => {
      submenu.setAttribute("aria-expanded", "false");
    });

    if (event.target && event.target.nextElementSibling) {
      isCurrentMenuId.setAttribute("aria-expanded", "true");
      event.target.nextElementSibling.classList.add("show");
    }
  }

  updateActive(event: any, onlyHis: boolean = false) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link.active"));
      this.removeActivation(items, onlyHis);
    }
    this.activateParentDropdown(event.target);
  }

  handleSidebarItemClick(event: any) {
    // show navbar-nav menu on click of icon sidebar menu
    let isCurrentMenuId = event.target.getAttribute("subitems");
    let isMenu = document.getElementById(isCurrentMenuId) as any;
    let dropDowns = Array.from(document.querySelectorAll("#navbar-nav .show"));
    dropDowns.forEach((node: any) => {
      node.classList.remove("show");
    });
    isMenu ? isMenu.classList.add("show") : null;

    const ul = document.getElementById("two-column-menu");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) =>
        x.classList.contains("active")
      );
      activeIconItems.forEach((item: any) => {
        item.classList.remove("active");
      });
    }
    event.target.classList.add("active");
    this.mobileItemClicked.emit();
  }

  // remove active items of two-column-menu
  removeActivation(items: any, onlyHis: boolean = false) {
    items.forEach((item: any) => {
      if (!onlyHis) {
        if (item.classList.contains("menu-link")) {
          if (!item.classList.contains("active")) {
            item.setAttribute("aria-expanded", false);
          }
          item.nextElementSibling.classList.remove("show");
        }
        if (item.classList.contains("nav-link")) {
          if (item.nextElementSibling) {
            item.nextElementSibling.classList.remove("show");
          }
          item.setAttribute("aria-expanded", false);
        }
      }
      item.classList.remove("active");
    });
  }

  activateIconSidebarActive(id: any) {
    var menu = document.querySelector(
      "#two-column-menu .simplebar-content-wrapper a[subitems='" +
        id +
        "'].nav-icon"
    );
    if (menu !== null) {
      menu.classList.add("active");
    }
  }

  activateParentDropdown(item: any) {
    // navbar-nav menu add active
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute(
        "aria-expanded",
        "true"
      );
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement
          .closest(".collapse")
          .classList.add("show");
        if (
          parentCollapseDiv.parentElement.closest(".collapse")
            .previousElementSibling
        )
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.classList.add("active");
      }
      this.activateIconSidebarActive(parentCollapseDiv.getAttribute("id"));
      return false;
    }
    return false;
  }

  // Limpa TUDO que pode ter sido marcado como ativo numa rodada anterior (grupos
  // abertos, ícone da coluna estreita, e também os próprios links com routerLink).
  // Não dá pra confiar que o routerLinkActive vai limpar sozinho: ele só troca a
  // classe quando o isActive muda de valor, então uma classe "active" adicionada
  // manualmente (por nós, numa rodada anterior) nunca é removida por ele.
  resetMenuState() {
    document
      .querySelectorAll('#navbar-nav .collapse.show')
      .forEach((el: any) => el.classList.remove('show'));
    document
      .querySelectorAll('#navbar-nav a.nav-link.active')
      .forEach((el: any) => {
        el.classList.remove('active');
        el.setAttribute('aria-expanded', 'false');
      });
    document
      .querySelectorAll('#two-column-menu a.nav-icon.active')
      .forEach((el: any) => el.classList.remove('active'));
  }

  initActiveMenu() {
    this.resetMenuState();
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      // Deriva o item ativo a partir da URL atual do Router (this.router.url), não de
      // window.location.pathname (que com hash routing é sempre "/") nem da classe
      // "active" (que acabamos de zerar acima). Compara o href de cada link (sem o
      // prefixo "#") com a rota atual.
      const currentUrl = this.router.url;
      const links = Array.from(ul.querySelectorAll('a.nav-link[href]'));
      const matchingMenuItem: any = links.find((a: any) => {
        const href = a.getAttribute('href') || '';
        const path = href.startsWith('#') ? href.slice(1) : href;
        return path === currentUrl;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
        document.body.classList.remove("twocolumn-panel");
      } else {
        // Tela atual não existe em nenhum item do menu: não há grupo pra destacar/expandir,
        // então recolhe o menu (mostra só a coluna estreita de ícones).
        document.body.classList.add("twocolumn-panel");
      }
    }
  }

  changeMenu() {
    this.topbar.changeMenu();
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  setMenuItens(value: any) {
    this.menuItems = value;
  }
}
